// LinearDecomposer.jsx (parent)
"use client";

import React, { useMemo, useState } from "react";
import { ToastContainer } from "react-toastify";
import { LayoutGrid } from "lucide-react";
import "react-toastify/dist/ReactToastify.css";

import WindowFilter from "../components/LinearDecomposer/WindowFilter";
import DoorGlassMatcher from "../components/LinearDecomposer/DoorGlassMatcher";
import GlassFinder from "../components/LinearDecomposer/GlassFinder";
import PDFGlassFinder from "../components/LinearDecomposer/PDFGlassFinder";
import GlassFinderPerCompany from "../components/LinearDecomposer/GlassFinderPerCompany";
import DoorFinder from "../components/LinearDecomposer/DoorFinder";

export default function LinearDecomposer() {
  const [tab, setTab] = useState("glass-finder-one");

  const tabs = useMemo(
    () => [
      // { id: "glass-finder", label: "Glass Finder" },
      // { id: "window-filter", label: "Energy Rating Filter" },
      // { id: "door-glass", label: "Glass & Frame Configurator" },
      // { id: "door-finder", label: "Window & Door Frame Finder" },
      { id: "glass-finder-one", label: "Glass Finder - Per Company" },
      { id: "glass-finder-all", label: "Glass Finder - All Company" },
    ],
    [],
  );

  return (
    <div className="min-h-screen bg-gray-100 px-3 sm:px-4 md:px-6 py-6">
      <div className="w-full max-w-full mx-auto">
        {/* Header */}
        <div className="mb-5 sm:mb-7">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 text-center">
            Window Energy Rating
          </h1>
          <div className="mt-3 h-px w-full bg-slate-200" />
        </div>

        {/* Shell */}
        <div className="w-full max-w-screen-2xl mx-auto rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
          {/* Tabs */}
          <div className="px-4 sm:px-6 lg:px-8 py-4 border-b border-slate-200 bg-white">
            <div className="flex items-start gap-4">
              <div className="min-w-0 w-full">
                <nav className="mt-4">
                  {/* Center wrapper */}
                  <div className="flex justify-center">
                    {/* Keep overflow scrolling on small screens, centred when it fits */}
                    <div className="relative flex w-full max-w-5xl rounded-2xl bg-white p-1.5 overflow-x-auto no-scrollbar">
                      <div className="flex w-full min-w-max justify-center gap-2">
                        {tabs.map((t) => {
                          const active = tab === t.id;
                          return (
                            <button
                              key={t.id}
                              onClick={() => setTab(t.id)}
                              className={[
                                "relative h-11 rounded-xl px-4 text-sm font-semibold outline-none whitespace-nowrap",
                                "transition-colors focus-visible:ring-2 focus-visible:ring-slate-400/70",
                                active
                                  ? "bg-slate-900 text-white shadow-sm"
                                  : "text-slate-700 hover:text-slate-900 bg-slate-100 hover:bg-slate-200",
                              ].join(" ")}
                              aria-current={active ? "page" : undefined}
                              type="button"
                            >
                              {t.label}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>

          {/* Content */}
          <main className="px-4 sm:px-6 lg:px-8 py-5 sm:py-6">
            {/* {tab === "window-filter" && <WindowFilter />}
                        {tab === "door-glass" && <DoorGlassMatcher />}
                        {tab === "glass-finder" && <GlassFinder />} */}
            {tab === "glass-finder-all" && (
              <PDFGlassFinder showToastContainer={false} />
            )}
            {tab === "glass-finder-one" && (
              <GlassFinderPerCompany showToastContainer={false} />
            )}
          </main>
        </div>

        <ToastContainer position="top-right" autoClose={4000} newestOnTop />
      </div>
    </div>
  );
}
